import React from "react";
import PropTypes from "prop-types";
import { AlertCircle } from "@opendate-app/setlist";

export const PUBLISHED_LOCK_NOTE = "This series is published. Change these for one date from the events table, or add dates with Add Dates.";
export const PUBLISHED_LOCK_NOTE_ID = "series-published-lock-note";

// A published series' dates own their schedule, ticket sets and capacity, and
// nothing pushes them (O-7157). A disabled fieldset turns off every control
// inside without each one needing its own prop.
const PublishedLock = ({ locked, children }) => (
  <fieldset className="series-published-lock" disabled={locked} aria-describedby={locked ? PUBLISHED_LOCK_NOTE_ID : undefined}>
    {children}
  </fieldset>
);

PublishedLock.propTypes = {
  locked: PropTypes.bool,
  children: PropTypes.node,
};

export const PublishedLockNote = ({ message = PUBLISHED_LOCK_NOTE }) => (
  <p id={PUBLISHED_LOCK_NOTE_ID} className="series-publishing-note" data-testid="published-lock-note">
    <AlertCircle width={16} height={16} aria-hidden="true" />
    {message}
  </p>
);

PublishedLockNote.propTypes = {
  message: PropTypes.string,
};

export default PublishedLock;
